var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xE5\xAF\xBC\xE5\x87\xBA"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\xE7\x9F\xA9\xE5\xBD\xA2",
    opacity: 0.01,
    width: 12,
    height: 12,
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.63104 10.0057H2.50512C2.22401 10.0057 1.99561 9.77727 1.99561 9.49612V2.50534C1.99561 2.22419 2.22401 1.99575 2.50512 1.99575H9.49488C9.77599 1.99575 10.0044 2.22419 10.0044 2.50534V4.63157C10.0044 4.90687 10.2269 5.12945 10.5022 5.12945C10.7775 5.12945 11 4.90687 11 4.63157V2.01186C11 1.45248 10.5461 1 9.98829 1H2.01171C1.45242 1 1 1.45395 1 2.01186V9.98814C1 10.5475 1.45388 11 2.01171 11H4.63104C4.9063 11 5.12884 10.7774 5.12884 10.5021C5.12884 10.2283 4.9063 10.0057 4.63104 10.0057V10.0057Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.8609 8.1411L10.8595 8.13961L9.01791 6.14855C8.83471 5.95048 8.53857 5.95048 8.35537 6.14855C8.17218 6.34661 8.17218 6.66679 8.35537 6.86485L9.40083 7.99516H6.46832C6.20937 7.99516 6 8.22152 6 8.50149C6 8.78146 6.20937 9.00782 6.46832 9.00782H9.39807L8.35537 10.1351C8.17218 10.3332 8.17218 10.6534 8.35537 10.8515C8.53857 11.0495 8.83471 11.0495 9.01791 10.8515L10.8306 8.89166C10.9339 8.79933 11 8.65934 11 8.50298C11 8.36001 10.9463 8.23343 10.8609 8.1411V8.1411Z",
    fill: "white"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg);
export default __webpack_public_path__ + "static/media/导出.f93b798b5b31da38273665c7b2c69f54.svg";
export { ForwardRef as ReactComponent };